<template>
  <div>
    <ViewTemplateWithTable :panel="panel" :templateList="templateList" :actions="actions" :filters="filters"
      :propsParam="propsParam">
      <div slot="content-buttons">
        <Button _key="btnSupplierCreate" title="Fornecedor" classIcon="fas fa-plus-circle" type="primary" size="small"
          eventName="supplierCreate" :clicked="create" />
      </div>
    </ViewTemplateWithTable>
  </div>
</template>

<script>
import ViewTemplateWithTable from "@nixweb/nixloc-ui/src/component/template/ViewTemplateWithTable.vue";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "SupplierListView",
  components: {
    ViewTemplateWithTable,
    Button,
  },
  data() {
    return {
      panel: {
        module: "Fornecedor",
        title: "Fornecedor",
        showFilter: true,
        showSearch: true,
        showButtons: true,
      },
      templateList: {
        urlGetApi: "/api/v1/supplier/get-all",
        urlDeleteAllApi: "/api/v1/supplier/delete",
        showChecks: true,
        headerTable: [
          {
            field: "companyName",
            title: "Razão Social/Nome",
            type: "link",
            routeName: "supplierUpdate",
            iconSearch: true,
          },
          {
            field: "tradeName",
            title: "Fantasia/Apelido",
            type: "text",
            iconSearch: true,
          },
          {
            field: "document",
            title: "CNPJ/CPF",
            type: "text",
            iconSearch: true,
          },
          {
            field: "categoryCustomerName",
            title: "Categoria",
            type: "text",
          },
          {
            field: "typeName",
            title: "Tipo",
            type: "text",
            iconSearch: false,
          },
          {
            field: "statusName",
            title: "Status",
            type: "class",
            fieldComparison: "statusName",
            classCssTitle: "text-center",
            classCssBody: [
              {
                classCss: "text-center badge badge-info",
                fieldComparison: "Ativo",
              },
              {
                classCss: "text-center badge badge-danger",
                fieldComparison: "Inativo",
              },
            ],
          },
        ],
      },
      actions: [
        { type: "delete", title: "Remover", description: "Remover", url: "/api/v1/supplier/delete", method: "delete", },
      ],
      filters: [
        {
          type: "multiOptions",
          title: "Categoria",
          field: "CategoryCustomerName",
          url: "/api/v1/crm/category-customer/select-all",
          value: "",
        },
        {
          type: "options",
          title: "Status",
          field: "StatusName",
          options: [
            { text: "Ativo", value: "Ativo" },
            { text: "Inativo", value: "Inativo" },
          ],
          value: [],
        },
        {
          type: "options",
          title: "Tipo",
          field: "TypeName",
          options: [
            { text: "PF", value: "PF" },
            { text: "PJ", value: "PJ" },
          ],
          value: [],
        },
      ],
      propsParam: {
        isCustomer: false,
        isSupplier: true,
      },
    };
  },
  computed: {
    ...mapGetters("generic", ["event"]),
  },
  methods: {
    ...mapMutations("generic", ["removeLoading"]),
    create() {
      this.$router.push({
        name: "supplierCreate",
      });
      this.removeLoading(["btnSupplierCreate"]);
    },
  },
};
</script>
